import api from '@/apis/di/accountAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('accountCombo', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_account',
    field: {
      key: 'account_id',
      code: 'account_number',
      name: 'account_name',
      quickFollow: 'inactive',
    },
    defaultSort: 'account_number',
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load tree
   */
  async loadTree(context, payload) {
    let res = null;

    try {
      context.commit('updateLoading', true);
      res = await api.getTree(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      //sắp xếp ở đây giảm cho server
      res = res.sortObject('account_number');
      context.commit('setItems', res);
    }

    return res;
  },
  setItemsCombo(context, res) {
    context.commit('setItems', res);
  },
  updateItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('updateItem', res);
  },
  insertItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('insertItem', res);
    context.commit('sortByCode');
  },
  deleteItemCombo(context, deleted) {
    //Commit thực hiện xóasinp
    context.commit('deleteItems', deleted);
  },
  updateItemQuickFllowCombo(context, res) {
    //Commit thực hiện xóasinp
    context.commit('updateItemQuickFllow', res);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
